'use client';
import type { CareerOrganizationPlayersResponse } from '@/lib/types';
import type { Locale } from '@/lib/localePath';
import CareerOrganizationFilterClient from './CareerOrganizationFilterClient';

export default function CareerOrganizationClient({ locale, slug, initial }: { locale: Locale; slug: string; initial: CareerOrganizationPlayersResponse }) {
  return <CareerOrganizationFilterClient locale={locale} primarySlug={slug} initial={initial} />;
}
